import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

const DEFAULT_OG_IMAGE = "https://static.prod-images.emergentagent.com/jobs/505cc825-2461-4ba6-922d-8b16e3d69521/images/0eff3543f3cc8d1b0ca6577e59cc501c74fa9a0fa2f0aa6f1feff4d68306894b.jpeg";
const DEFAULT_TITLE = "ÀsÀNigHT Worldwide — Discover the Depth of Yorùbá Culture";
const DEFAULT_DESC = "ÀsÀNigHT Worldwide preserves and shares Yorùbá culture, traditions, philosophy, Òrìṣà spirituality, and history with a global audience through authentic educational content.";

function upsertMeta(selector, attr, name, content) {
  let tag = document.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function useSEO(title, description, image) {
  React.useEffect(() => {
    const fullTitle = title ? `${title} · ÀsÀNigHT Worldwide` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const img = image || DEFAULT_OG_IMAGE;
    const url = typeof window !== "undefined" ? window.location.href : "";
    document.title = fullTitle;
    const d = document.querySelector('meta[name="description"]');
    if (d) d.setAttribute("content", desc);
    upsertMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    upsertMeta('meta[property="og:description"]', "property", "og:description", desc);
    upsertMeta('meta[property="og:image"]', "property", "og:image", img);
    upsertMeta('meta[property="og:url"]', "property", "og:url", url);
    upsertMeta('meta[property="og:type"]', "property", "og:type", "website");
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", desc);
    upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", img);
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title, description, image]);
}
